import { AnyAction } from "redux";
import actions from "../../util/actions";
import { MinistryLandingPageReducerState } from "../../interfaces";

const initialState: MinistryLandingPageReducerState = {
  initial: false,
  loading: true,
  error: null,
  response: null,
  content: ""
};

const reducer = (state = initialState, action: AnyAction): MinistryLandingPageReducerState => {
  switch (action.type) {
    case actions.MINISTRY_LANDING_PAGE_HTTP_LOADING:
      return { ...state, response: null, loading: true, error: null };
    case actions.MINISTRY_LANDING_PAGE_HTTP_ERROR:
      if (action.payload.clear) {
        return { ...state, response: null, loading: false, error: null };
      }
      return { ...state, response: null, loading: false, error: { ...action.payload } };
    case actions.MINISTRY_LANDING_PAGE_HTTP_COMPLETE:
      return { ...state, initial: true, response: action.payload.response, loading: false, error: null };
    case actions.SET_MINISTRY_LANDING_PAGE_DETAILS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
